import { gql } from '@apollo/client' ;

export default gql`
  mutation changePassword(
    $input: ChangePasswordInput!,
  ) {
    changePassword(input: $input) {
      errors {
        path
        message
      }
    }
  }
`;
